<div  class="ui-g">
    <div class="ui-g-12" *ngIf="rentalDocs!=null && rentalDocs.length>0">
      <span class="info-label" translate>label_rental_docs_uploaded</span>
    </div>
  <div class="ui-g-12 ui-md-2 ui-lg-2"  *ngFor="let user of rentalDocs">
    <img class="img-doc" src="{{( user.documentFile !== '' &&  user.documentFile !== null) ? (profileImageUrl + user.documentFile) : '/assets/images/temp/doc.png' }}"
      onerror="src='/assets/images/temp/doc.png'" />
  </div>
</div>